import React, { Component } from 'react'
import { connect } from 'react-redux'

import InputStandard from 'components/input/standard'
import Button from 'components/button/button'
import copy from 'fast-copy'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import { getAccountUsers, getCurrentAccount } from 'state/selectors'

import { saveItem } from 'state/actions'
import { doSort, stringIsEmpty } from 'utils'

import GuestList from 'components/modal/modal-components/guest-list'

class ModalTeam extends Component {
	state = {
		id: null,
		name: '',
		includedTeamEmails: [], // we're not using IDs, cause some may be invitations only
		includedAdminEmails: []
	}

	getEmails = type => {
		const {
			users,
			data
		} = this.props

		const emailsList = []

		data[type == 'team' ? 'userIds' : 'adminIds'].forEach(userId => {
			const userObject = users.find(user => {
				return user.id === userId
			})

			if(userObject){
				emailsList.push(userObject.email)
			}
		})

		return emailsList
	}

	componentDidMount = _ => {
		const {
			data,
		} = this.props

    	setTimeout(_ => {
    		this.refs.teamName.inputRef.focus()
		}, 1)

		if(data && data.id){
			const team = data

			this.setState({
				id: team.id,
				name: team.name,
				includedTeamEmails: this.getEmails('team'),
				includedAdminEmails: this.getEmails('admin')
			})
		}
	}	

	handleChange = e => {
		this.setState({
			name: e.target.value
		})
	}

	handleChangeUsers = (user, index) => {
		const key = !index ? 'includedTeamEmails' : 'includedAdminEmails'

		let tempState = copy(this.state)

		const indexIfExists = tempState[key].indexOf(user.email)

		if(indexIfExists === -1){
			tempState[key].push(user.email)

			// added an admin, so they better be a member!
			if(index == 1){
				const memberIndexIfExists = tempState.includedTeamEmails.findIndex(teamEmail => {
					return teamEmail === user.email
				})

				if(memberIndexIfExists < 0){
					tempState.includedTeamEmails.push(user.email)
				}
			}
		}else{
			tempState[key].splice(indexIfExists, 1)

			// removed a user, so remove admin if applicable too
			if(!index){
				const adminIndexIfExists = tempState.includedAdminEmails.findIndex(adminEmail => {
					return adminEmail == user.email
				})

				if(adminIndexIfExists !== -1){
					tempState.includedAdminEmails.splice(adminIndexIfExists, 1)
				}
			}
		}

		this.setState({
			...tempState
		})
	}

	saveTeam = _ => {
		let requestData = {
			...this.state
		}

		if(stringIsEmpty(requestData.name)) {
			return this.props.handleError('Please enter a team name.')
		}

		if(!requestData.includedTeamEmails.length){
			return this.props.handleError("You can't create an empty team.")
		}

		if(!requestData.includedAdminEmails.length){
			return this.props.handleError("Teams need at least one admin.")
		}

		this.props.setLoading(true)
		requestData.account_id = this.props.account.id

		this.props.saveItem(requestData, 'team', _ => {
			this.props.setLoading(false)
			this.props.closeCallback()
		})
	}

	render() {
		const {
			users
		} = this.props

		const {
			includedTeamEmails,
			includedAdminEmails
		} = this.state

		let allSelectableUsers = [
			...users
		]

		allSelectableUsers = doSort(allSelectableUsers, 'alpha', 'first_name')
		
		allSelectableUsers.sort((a, b) => {
			const aEmail = a.email ? a.email : a.recipient_email
			const bEmail = b.email ? b.email : b.recipient_email

			const aChecked = includedTeamEmails.indexOf(aEmail) !== -1
			const bChecked = includedTeamEmails.indexOf(bEmail) !== -1

			return (aChecked === bChecked)? 0 : aChecked? -1 : 1;
		})

		return(
			<div>
				<div className={'modal-team borders no-border-bottom'}>
					<InputStandard 
						outlineOnFocus={true} 
						ref="teamName" 
						callback={this.saveTeam} 
						value={this.state.name} 
						onChange={this.handleChange} 
						placeholder='Team name (e.g "Design team")' 
					/>
					<div className="input-wrap">
						<GuestList
							users={allSelectableUsers}
							parentEntityId={this.props.data ? this.props.data.id : null}
							handleChangeUsers={this.handleChangeUsers}
							includedKeyArrays={[includedTeamEmails, includedAdminEmails]}
							checkKeys={['email', 'recipient_email']}
							hasSearch={true}
							hasRoles={true}
							canSelect={true}
						/>
					</div>
				</div>
				<ValidateResponse 
					dismissCallback={this.props.handleDismiss} 
					response={this.props.validateResponse} 
				/>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.saveTeam} 
					label={'Save'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={this.props.closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
  return {
	users: getAccountUsers(state),
	account: getCurrentAccount(state)
  };
}

const ModalTeamWithValidateResponse = withValidateResponse(ModalTeam)

export default connect(mapStateToProps, { 
	saveItem, 
})(ModalTeamWithValidateResponse)


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-team.jsx